import style from './EhrFiles.module.scss';

import { FileAssetList } from '@components/FileAssetList';
import { FileAsset } from '@store/models/FileAsset';
import { AddFieldButton } from '@components/ActionButtons/AddFieldButton';
import { EhrPageAttributes } from 'chaika-test-attributes';

export interface EhrFilesProps {}

interface Props extends EhrFilesProps {
    addMode: boolean;
    files: FileAsset[];
    onAddClick(): void;
    onDeleteFileClick(fileName: string): void;
}

export function EhrFiles({ addMode, files, onAddClick, onDeleteFileClick }: Props) {
    return (
        <div className={style.root}>
            <div className={style.files}>
                <FileAssetList
                    assets={files}
                    onDeleteCLick={onDeleteFileClick}
                />
            </div>
            {!addMode && (
                <div className={style.addButton}>
                    <AddFieldButton
                        dataTest={EhrPageAttributes.AddFile}
                        onAddClick={onAddClick}
                    />
                </div>
            )}
        </div>
    );
}
